import { render, staticRenderFns } from "./ReviewModify.vue?vue&type=template&id=59977942&"
import script from "./ReviewModify.vue?vue&type=script&lang=js&"
export * from "./ReviewModify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports